import { PathAPI } from '../../../api/datamanager/PathAPI';

export class PathsCommand {
    getByLine(edition, lineId, providerId, successCallback, errorCallback) {
        const apiResult = PathAPI.listByLine(edition.network, lineId, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getIntervals(edition, pathId, successCallback, errorCallback) {
        const apiResult = PathAPI.getIntervals(edition.network, pathId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getNotes(edition, pathId, successCallback, errorCallback) {
        const apiResult = PathAPI.getNotes(edition.network, pathId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, path, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(undefined === path.id || 0 === path.id) {
            apiResult = PathAPI.create(edition.network, path);
            successMessage = "Percurso criado com sucesso";
        }
        else {
            apiResult = PathAPI.update(edition.network, path.id, path);
            successMessage = "Percurso editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    copy(edition, path, successCallback, errorCallback) {
        const apiResult = PathAPI.copy(edition.network, path);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveIntervals(edition, pathId, intervals, successCallback, errorCallback) {
        const apiResult = PathAPI.saveIntervals(edition.network, pathId, intervals);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Periodos de Funcionamento guardados com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveNotes(edition, pathId, notes, successCallback, errorCallback) {
        const apiResult = PathAPI.saveNotes(edition.network, pathId, notes);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Notas guardadas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, pathId, successCallback, errorCallback) {
        const apiResult = PathAPI.delete(edition.network, pathId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Percurso eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
